import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type SeparatorProps = {
  className?: string;
} & React.ComponentPropsWithoutRef<'span'>;
export function Separator(t0) {
  const $ = _c(4);
  let {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("relative border-l min-h-5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  className = t1;
  let t2;
  if ($[2] !== className) {
    t2 = <span className={className} aria-hidden="true" />;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}